import { useState } from "react";
import ModalNotificacion from "./ModalNotificacion";
import styles from "./TrabajaConNosotros.module.css";

export default function TrabajaConNosotros() {
  const [form, setForm] = useState({
    nombre: "",
    email: "",
    archivo: null,
  });
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalTipo, setModalTipo] = useState("success");

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "archivo") {
      setForm({ ...form, archivo: files[0] });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("nombre", form.nombre);
    formData.append("email", form.email);
    formData.append("archivo", form.archivo);

    const response = await fetch("trabaja.php", {
      method: "POST",
      body: formData,
    });

    const result = await response.text();
    if (result === "success") {
      setModalTipo("success");
      setModalMessage("Mensaje enviado correctamente.");
      setForm({ name: "", email: "", message: "" });
    } else {
      setModalTipo("error");
      setModalMessage("Hubo un error al enviar. Intenta más tarde.");
    }
    setModalVisible(true);
  };

  return (
    <>
      <section className={styles.section} id="contacto">
        <div className={styles.container}>
          <div className={styles.left}>
            <div className={styles.header}>
              <h2>DEJANOS TU CV</h2>
              <p>
                Si quieres formar parte del estudio y formarte profesionalmente
                para tu futuro, déjanos tu CV en el siguiente formulario.
              </p>
            </div>
            <form onSubmit={handleSubmit} className={styles.formulario}>
              <input
                type="text"
                name="nombre"
                placeholder="Nombre*"
                value={form.nombre}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Correo electrónico*"
                value={form.email}
                onChange={handleChange}
                required
              />
              <label htmlFor="archivo" className={styles.customFile}>
                {form.archivo ? form.archivo.name : "ADJUNTA TU CV"}
              </label>
              <input
                type="file"
                id="archivo"
                name="archivo"
                className={styles.fileInput}
                onChange={handleChange}
                required
              />
              <button type="submit">Enviar</button>
            </form>
          </div>
          <div className={styles.right}>
            <img
              src="/images/contact.png"
              alt="Oficina contacto"
              className={styles.image}
            />
          </div>
        </div>
      </section>

      <ModalNotificacion
        mensaje={modalMessage}
        visible={modalVisible}
        tipo={modalTipo}
        onClose={() => setModalVisible(false)}
      />
    </>
  );
}
